import React, { lazy, Suspense } from 'react';
import { Navigate, Route, Routes as Switch } from 'react-router-dom';
import FullLayout from 'src/components/layouts/FullLayout';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthRoute from 'src/components/route/AuthRoute';
import GuestRoute from 'src/components/route/GuestRoute';
import Login from './views/authentication/Login';
import Logout from './views/authentication/Logout';
import Search from './views/guest/Search';
import NotFound from './views/NotFound';
//import Login from './views/login/Login';
//import Logout from './views/login/Logout';
//import NotFound from 'src/views/pages/NotFound';

export const routes = [
  {
    path: 'dashboard',
    file: () => import('src/views/pages/HomePage'),
  },
  {
    path: 'replacement-matrix',
    file: () => import('src/views/matrix/Matrix'),
  },
  {
    path: 'devices',
    file: () => import('src/views/devices/Devices'),
  },
  {
    path: 'devices/add',
    file: () => import('src/views/devices/CreateDevices'),
  },
  {
    path: 'devices/confirmation',
    file: () => import('src/views/devices/DeviceConfirmation'),
  },
  {
    path: 'devices/:id',
    file: () => import('src/views/devices/UpdateDevice'),
  },

  {
    path: '/devices',
    file: () => import('src/views/devices/Devices'),
  },
  {
    path: '/manufacturers',
    file: () => import('src/views/manufacturers/Manufacturers'),
  },
  {
    path: '/manufacturers/add',
    file: () => import('src/views/manufacturers/CreateManufacture'),
  },
  {
    path: '/manufacturers/:id',
    file: () => import('src/views/manufacturers/UpdateManufacture'),
  },
  {
    path: '/phonetypes',
    file: () => import('src/views/phonetypes/PhoneTypes'),
  },
  {
    path: '/phone_types/add',
    file: () => import('src/views/phonetypes/CreatePhoneType'),
  },
  {
    path: '/phone_types/:id',
    file: () => import('src/views/phonetypes/UpdatePhoneType'),
  },
  {
    path: '/skus',
    file: () => import('src/views/skucat/SkuCats'),
  },
  {
    path: '/skus/add',
    file: () => import('src/views/skucat/CreateSkuCats'),
  },
  {
    path: '/skus/:id',
    file: () => import('src/views/skucat/UpdateSkuCats'),
  },
  {
    path: '/inventory_owners',
    file: () => import('src/views/invotoryowners/Inventory'),
  },
  {
    path: '/inventory_owners/add',
    file: () => import('src/views/invotoryowners/CreateInventory'),
  },
  {
    path: '/inventory_owners/:id',
    file: () => import('src/views/invotoryowners/UpdateInventory'),
  },
  {
    path: '/tiers',
    file: () => import('src/views/tiers/Tiers'),
  },
  {
    path: '/tiers/add',
    file: () => import('src/views/tiers/CreateTiers'),
  },
  {
    path: '/tiers/:id',
    file: () => import('src/views/tiers/UpdateTiers'),
  },
  {
    path: '/fees',
    file: () => import('src/views/fee_structures/Fee'),
  },
  {
    path: '/fees/add',
    file: () => import('src/views/fee_structures/CreateFee'),
  },
  {
    path: '/fees/:id',
    file: () => import('src/views/fee_structures/UpdateFee'),
  },
  {
    path: '/exports',
    file: () => import('src/views/exports/ExportPage'),
  },
  {
    path: '/imports',
    file: () => import('src/views/import/ImportPage'),
  },
];

function Routes() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        <Route path="/" element={<Navigate to="/dashboard" replace={true} />} />
        <Route path="/404" element={<NotFound />} />
        <Route
          path="/login"
          element={
            <GuestRoute>
              <Login />
            </GuestRoute>
          }
        />
        <Route
          path="/disconnected"
          element={
            <GuestRoute>
              <Logout />
            </GuestRoute>
          }
        />
        <Route
          path="/hub/bell/search"
          element={
            <GuestRoute>
              <Search />
            </GuestRoute>
          }
        />
         <Route
          path="/hub/virgin/search"
          element={
            <GuestRoute>
              <Search />
            </GuestRoute>
          }
        />

        {routes.map((item, index) => {
          const A = lazy(() => item.file());

          return (
            <Route
              path={item.path}
              element={
                <AuthRoute>
                  <FullLayout>
                    <A />
                  </FullLayout>
                </AuthRoute>
              }
              key={index}
            />
          );
        })}

        <Route
          path="/*"
          element={
            <AuthRoute>
              <FullLayout>
                <NotFound />
              </FullLayout>
            </AuthRoute>
          }
        />
      </Switch>
    </Suspense>
  );
}
export default Routes;
